/* apex-guide.js — the guide article's table of contents.

   The list is built from the article's own h2s rather than from a setting,
   because the guides are imported and nobody is going to hand-maintain a
   contents list for 324 of them. The script gives each h2 an id and a number,
   fills both copies of the nav (the sticky rail and the phone disclosure), and
   follows the reading position.

   Progressive: with no h2s, or no JS, the article reads exactly the same. The
   rail is simply hidden — .is-empty in apex.css §20 — rather than left as an
   empty box. */
(function () {
  var prose = document.getElementById('aprose');
  if (!prose) return;

  var layout = prose.closest('.alayout');
  var navs = [].slice.call(document.querySelectorAll('[data-atoc]'));
  /* the FAQ's groups are divs, not headings — the page says what to list */
  var from = prose.getAttribute('data-atoc-from') || 'h2';
  var heads = [].slice.call(prose.querySelectorAll(from));

  if (!heads.length || !navs.length) {
    if (layout) layout.classList.add('is-empty');
    return;
  }

  var still = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* numbering an ordered guide helps; numbering a set of FAQ groups does not */
  var number = prose.getAttribute('data-atoc-number') !== 'off';

  heads.forEach(function (h, i) {
    if (!h.id) h.id = 'aprose-s' + i;
    if (!number) return;
    /* the number belongs to the heading, so it travels with it if the
       reader copies the text or lands on the anchor */
    var n = document.createElement('span');
    n.className = 'abn';
    n.setAttribute('aria-hidden', 'true');
    n.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
    h.insertBefore(n, h.firstChild);
  });

  navs.forEach(function (nav) {
    heads.forEach(function (h, i) {
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.dataset.i = String(i);
      /* a heading may carry its own number — the policies are written "1. When
         We Will Refund You in Full" — so drop the separator with the digits,
         or the list reads ". When We Will Refund You in Full" */
      var label = (h.textContent || '').replace(/^\s*\d+\s*[.)–—-]?\s*/, '').trim();
      if (number) {
        /* the list carries the same numbers as the headings, so a reader can
           match one to the other without counting */
        var ni = document.createElement('span');
        ni.className = 'abn';
        ni.setAttribute('aria-hidden', 'true');
        ni.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        a.appendChild(ni);
      }
      a.appendChild(document.createTextNode(label));
      if (i === 0) a.setAttribute('aria-current', 'true');
      nav.appendChild(a);
    });
  });

  var links = [].slice.call(document.querySelectorAll('[data-atoc] a'));

  function mark(i) {
    links.forEach(function (a) {
      if (a.dataset.i === String(i)) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
  }

  /* Which heading is the reader in? The last one whose top has passed the
     header. Cheap enough to run per frame, and exact — an IntersectionObserver
     would report the heading entering, not the section being read. */
  var queued = false;
  function spy() {
    queued = false;
    var line = 150, i = 0;
    for (var k = 0; k < heads.length; k++) {
      if (heads[k].getBoundingClientRect().top <= line) i = k; else break;
    }
    mark(i);
  }
  window.addEventListener('scroll', function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(spy);
  }, { passive: true });
  spy();

  /* One delegated listener on the layout covers both navs. */
  if (layout) {
    layout.addEventListener('click', function (e) {
      var a = e.target.closest('[data-atoc] a');
      if (!a) return;
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: still.matches ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', a.getAttribute('href'));
      mark(Number(a.dataset.i));
      /* a disclosure that stays open hides the thing it just jumped to */
      var d = layout.querySelector('.aside__m[open]');
      if (d) d.open = false;
    });
  }
})();
